// extracted by mini-css-extract-plugin
export default {"container":"CloseablePanel_container__padHi","heading":"CloseablePanel_heading__8+9RU"};